import React, { SFC } from "react";
import "./style.scss";

type PropsType = {
    level?: 1 | 2 | 3 | 4 | 5;
    underline?: boolean;
};

const Title = (props): SFC => {
    const element = props.level === undefined ? <div /> : `h${props.level}`;
    const className = props.underline === undefined ? "Title" : "Title Title--underline";

    return <div className={className}>{props.children}</div>;
};

export default Title;
